export default __webpack_public_path__ + "static/media/img_astros.5b9654f0.jpg";